import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Carousel from "react-bootstrap/Carousel";
import ReactPaginate from "react-paginate";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [jobs, setJobs] = useState([]);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");

  // tratamento e paginação das vagas
  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;
  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const currentEffectiveJobs = filteredJobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs,
  );

  const pageCountEffectiveJobs = Math.ceil(filteredJobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs.length;
    setItemOffsetEffectiveJobs(newOffset);
    setCurrentPage(event.selected);

    document.getElementById("vagas").scrollIntoView();
  };

  const toggleBurguerMenu = () => {
    const burguerMenu = document.querySelector(".burguer-menu");
    const burguerContent = document.querySelector(".burguer-content");

    burguerMenu.onclick = function () {
      burguerContent.classList.toggle("show-menu");
    };

    burguerContent.onclick = function () {
      burguerContent.classList.remove("show-menu");
    };

    document.onclick = function (e) {
      if (
        !burguerMenu.contains(e.target) &&
        !burguerContent.contains(e.target)
      ) {
        burguerContent.classList.remove("show-menu");
      }
    };
  };

  const onChangeFilterJobs = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  useEffect(() => {
    toggleBurguerMenu();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "heineken",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();
          console.log("result :>> ", jobsData);

          setJobs(jobsData.jobPositionList);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  return (
    <div>
      <nav className="bg-[#EAEAE8] z-50 relative">
        <div className="flex flex-wrap items-end justify-between p-4 relative">
          <div className="w-[15%] max-[768px]:w-[40%]">
            <img
              src="./assets/images/vagas_heineken.logo.png"
              alt="heineken Logo"
              className="w-full"
            />
          </div>

          <div className="burguer-menu cursor-pointer mb-1">
            <img
              src="./assets/icons/Menu.svg"
              alt="menu"
              className="rounded-none"
            />
          </div>

          <ul id="content-burger-menu" className="burguer-content list-menu">
            <li>
              <a href="#empresa" className="text-[#00530E]">
                A EMPRESA
              </a>
            </li>
            <li>
              <a href="#valores" className="text-[#00530E]">
                &nbsp;| VALORES
              </a>
            </li>
            <li>
              <a href="#comportamentos" className="text-[#00530E]">
                &nbsp;| COMPORTAMENTOS
              </a>
            </li>
            <li>
              <a href="#áreas" className="text-[#00530E]">
                &nbsp;| NOSSAS ÁREAS
              </a>
            </li>
            <li>
              <a href="#gente" className="text-[#00530E]">
                &nbsp;| NOSSA GENTE
              </a>
            </li>
            <li>
              <a href="#seletivo" className="text-[#00530E]">
                &nbsp;| PROCESSO SELETIVO
              </a>
            </li>
            <li>
              <a href="#vagas" className="text-[#00530E]">
                &nbsp;| VAGAS
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <img
        src="./assets/images/vagas_heineken.headbg.png"
        alt="banner"
        className="w-full rounded-none relative"
      />
      <div className="w-full">
        <img
          src="./assets/images/vagas_heineken.fullbanner.png"
          alt="banner"
          className="w-full mt-[-8%]"
        />
        <div
          className="flex flex-col absolute top-[25vw] left-7 z-40 text-[3.5vw] leading-[0.7] font-[HEINEKEN-ExtraBold]
        max-[768px]:top-[30vw] max-[768px]:left-4"
        >
          <p className="p-0 text-white">NOSSA ESTRELA</p>
          <p className="p-0 text-[#00530E]">EM CADA CORAÇÃO</p>
          <p className="p-0 text-white">E EM CADA COPO</p>
          <p className="p-0 text-[#00530E]">BRASILEIRO</p>
        </div>
      </div>

      <h1
        id="empresa"
        className="text-7xl text-[#00530E] font-[HEINEKEN-ExtraBold] px-[7vw] max-[768px]:text-4xl"
      >
        A EMPRESA
      </h1>
      <div className="flex flex-row flex-wrap">
        <div className="w-[50%] flex flex-col justify-center mt-12 px-[7vw] py-6 max-[768px]:mt-14 max-[768px]:w-full">
          <h2 className="text-2xl relative pl-8">
            História no Brasil
            <br /> Uma cervejaria internacional com presença local
          </h2>
          <p className="text-lg text-[#00530e] my-8">
            Uma cervejaria interacional, com presença local. A HEINEKEN chegou
            ao Brasil em maio de 2010, após a aquisição da divisão de cerveja do
            Grupo FEMSA. Em 2017, adquiriu a Brasil Kirin Holding S.A, dando um
            novo rumo para a sua história no país. A Companhia tornou-se o
            segundo maior player nacional de cerveja e viu sua operação
            multiplicar de 2 para 13 mil colaboradores, de 5 para 15 unidades
            produtivas, além dos 31 centros de distribuição espalhados pelos
            quatro cantos do país. Com a aquisição, a empresa também passou a
            atuar no mercado de bebidas não alcoólicas, como refrescos e
            refrigerantes.
          </p>
          <h2 className="text-2xl relative pl-8">
            História Global
            <br /> Tradição familiar, mas com presença global
          </h2>
        </div>
        <img
          src="./assets/images/vagas_heineken.empresfull.png"
          alt="banner"
          className="w-[40%] max-[768px]:px-[7vw] max-[768px]:w-full"
        />
      </div>

      <div className="flex flex-row flex-wrap">
        <div className="flex flex-col justify-center mt-12 px-[7vw] py-6 max-[768px]:mt-14">
          <h1
            id="valores"
            className="text-7xl py-5 text-[#00530E] font-[HEINEKEN-ExtraBold] max-[768px]:text-4xl"
          >
            NOSSOS VALORES
          </h1>

          <div className="flex flex-wrap items-start gap-4 max-[768px]:flex-col">
            <div className="flex flex-col items-center w-[23%] max-[768px]:w-full">
              <img
                src="./assets/images/vagas_heineken.nossos.png"
                alt="banner"
                className=""
              />
              <h6 className="text-2xl my-3 text-[#00530E] relative">
                RESPEITO
              </h6>
              <div>
                <p className="text-[#00530E] text-center text-lg">
                  Criamos um ambiente empático inclusivo, que se preocupa com as
                  pessoas, o planeta e a diversidade. Incentivamos a escuta
                  ativa, fazemos o que falamos e somos transparentes na forma de
                  comunicar.
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center w-[23%] max-[768px]:w-full">
              <img
                src="./assets/images/vagas_heineken.nossos2.png"
                alt="banner"
                className=""
              />
              <h6 className="text-2xl my-3 text-[#00530E] relative after:bg-[#7ab931]">
                PAIXÃO
              </h6>
              <div>
                <p className="text-[#00530E] text-center text-lg">
                  Somos motivados por construir as melhores marcas e produtos
                  para os nossos consumidores. Temos orgulho em ser HEINEKEN, da
                  nossa história e das nossas pessoas.
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center w-[23%] max-[768px]:w-full">
              <img
                src="./assets/images/vagas_heineken.nossos4.png"
                alt="banner"
                className=""
              />
              <h6 className="text-2xl my-3 text-[#00530E] relative after:bg-[#fad15b]">
                CORAGEM
              </h6>
              <div>
                <p className="text-[#00530E] text-center text-lg">
                  Prezamos pela qualidade em tudo o que fazemos, dos produtos às
                  relações, pensando no longo prazo. Entregamos sempre o nosso
                  melhor com inovação e agilidade.
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center w-[23%] max-[768px]:w-full">
              <img
                src="./assets/images/vagas_heineken.nossos5.png"
                alt="banner"
                className=""
              />
              <h6 className="text-2xl my-3 text-[#00530E] relative after:bg-[#e13530]">
                DIVERSÃO
              </h6>
              <div>
                <p className="text-[#00530E] text-center text-lg">
                  Buscamos um ambiente de trabalho agradável e informal.
                  Celebramos e reconhecemos pequenas e grandes conquistas com
                  alegria, segurança e responsabilidade.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col justify-center mt-12 py-6 max-[768px]:mt-14">
        <h1
          id="comportamentos"
          className="text-5xl px-[7vw] text-[#00530E] font-[HEINEKEN-ExtraBold] max-[768px]:text-4xl"
        >
          NOSSOS COMPORTAMENTOS
        </h1>
        <div className="flex flex-col justify-center bg-wrapper-1">
          <h1 className="text-5xl mb-12 text-center text-[#00530E] font-[HEINEKEN-ExtraBold]">
            ENTREGAR
          </h1>
          <div className="flex flex-wrap justify-center gap-14 text-[#00530E] px-[7vw] max-[768px]:flex-col">
            <div className="flex flex-col w-[40%] max-[768px]:w-full max-[768px]:text-center">
              <h3>JOGAR PARA VENCER E CELEBRAR O SUCESSO</h3>
              <p className="text-xl">
                Somos motivados, apaixonados e determinados - Nós estamos aqui
                para vencer!
                <br />
                <br />
                Nós torcemos, nos divertimos e celebramos juntos o nosso
                sucesso.
              </p>
            </div>
            <div className="flex flex-col w-[40%] max-[768px]:w-full max-[768px]:text-center">
              <h3>ENTREGAR OS RESULTADOS</h3>
              <p className="text-xl">
                Assumimos responsabilidade individual pela entrega dos
                resultados.
                <br />
                <br />
                Decidimos e fazemos, com uma abordagem prática, objetiva,
                compreensível e diciplinada. <br />
                Nós simplificamos e agimos com agilidade.
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center bg-wrapper-2">
          <h1 className="text-5xl mb-12 text-center text-[#00530E] font-[HEINEKEN-ExtraBold]">
            MOLDAR
          </h1>
          <div className="flex flex-wrap justify-center gap-14 text-[#00530E] px-[7vw] max-[768px]:flex-col">
            <div className="flex flex-col w-[40%] max-[768px]:w-full max-[768px]:text-center">
              <h3>PENSAR PRIMEIRO NO CONSUMIDOR E NO CLIENTE</h3>
              <p className="text-xl">
                Entendemos as necessidades dos nossos consumidores e clientes,
                aproveitando as principais ideias e dados. Estamos um passo à
                frente dos nossos concorrentes.
                <br />
                <br />
                Somos criativos e inovadores, antecipamos tendências e agimos
                com rapidez para torná-las reais. Testamos, aprendemos e nos
                adaptamos.
              </p>
            </div>
            <div className="flex flex-col w-[40%] max-[768px]:w-full max-[768px]:text-center">
              <h3>TOMAR ATITUDES CORAJOSAS</h3>
              <p className="text-xl">
                Agimos como empreendedores: explorando oportunidades, sendo
                pioneiros e priorizando o que é importante para o negócio.
                <br />
                <br />
                Somos corajosos e assumimos riscos, sempre curiosos e em busca
                de oportunidades de vencer no mercado.
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center bg-wrapper-3">
          <h1 className="text-5xl mb-12 text-center text-[#00530E] font-[HEINEKEN-ExtraBold]">
            CONECTAR
          </h1>
          <div className="flex flex-wrap justify-center gap-14 text-[#00530E] px-[7vw] max-[768px]:flex-col">
            <div className="flex flex-col w-[40%] max-[768px]:w-full max-[768px]:text-center">
              <h3>PROTAGONIZAR UMA CULTURA DE PERTENCIMENTO</h3>
              <p className="text-xl">
                Somos uma empresa de pessoas que cuidam umas das outras: todos
                nós contribuímos para criar e manter uma cultura segura,
                respeitosa e inclusiva para todos.
                <br />
                <br />
                Falamos com o coração e nos conectamos por meio da autenticidade
                e da vulnerabilidade.
              </p>
            </div>
            <div className="flex flex-col w-[40%] max-[768px]:w-full max-[768px]:text-center">
              <h3>APRENDER, COMPARTILHAR E REAPLICAR</h3>
              <p className="text-xl">
                Nós nos conectamos entre áreas e eliminamos barreiras,
                potencializando a colaboração entre times e parceiros.
                <br />
                <br />
                Valorizamos os bons exemplos e boas práticas do mercado.
                Abraçamos as oportunidades de nos inspirar com orgulho no bom
                trabalho de outras pessoas e empresas.
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center bg-wrapper-4">
          <h1 className="text-5xl mb-12 text-center text-[#00530E] font-[HEINEKEN-ExtraBold]">
            DESENVOLVER
          </h1>
          <div className="flex flex-wrap justify-center gap-14 text-[#00530E] px-[7vw] max-[768px]:flex-col">
            <div className="flex flex-col w-[40%] max-[768px]:w-full max-[768px]:text-center">
              <h3>TER CONVERSAS VERDADEIRAS E TRANSPARENTES</h3>
              <p className="text-xl">
                Incentivamos a prática de dar e receber feedback como ferramenta
                de desenvolvimento das nossas pessoas e para crescimento da
                nossa empresa.
                <br />
                <br />
                Temos conversas corajosas e verdadeiras. Falamos
                construtivamente o que pensamos enquanto estamos abertos a ouvir
                diferentes pontos de vista.
              </p>
            </div>
            <div className="flex flex-col w-[40%] max-[768px]:w-full max-[768px]:text-center">
              <h3>ABRAÇAR O APRENDIZADO E O CONHECIMENTO</h3>
              <p className="text-xl">
                Queremos aprender continuamente: para nos desenvolver e para
                aprimorar nossas equipes e nossa empresa.
                <br />
                <br />
                Abraçamos o novo. Somos curiosos e buscamos desafios que nos
                tirem da nossa zona de conforto.
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center bg-wrapper-5">
          <h1
            id="áreas"
            className="text-5xl mb-12 text-center text-white font-[HEINEKEN-ExtraBold]"
          >
            ÁREAS DE ATUAÇÃO
          </h1>
          <Carousel>
            <Carousel.Item interval={2000}>
              <div className="flex justify-center gap-8 p-12 max-[768px]:flex-col">
                <div className="flex flex-col items-center">
                  <div className="w-[12vw] h-[12vw] flex items-center justify-center border-2 border-[#eaeae8] rounded-full">
                    <img
                      src="./assets/images/vagas_heineken.areas2.png"
                      alt="banner"
                      className="w-[60%] mb-2 ml-2"
                    />
                  </div>
                  <h4 className="mt-1 text-white">JURÍDICO</h4>
                </div>
                <div className="flex flex-col items-center">
                  <div className="w-[12vw] h-[12vw] flex items-center justify-center border-2 border-[#eaeae8] rounded-full">
                    <img
                      src="./assets/images/vagas_heineken.areas1.png"
                      alt="banner"
                      className="w-[60%]"
                    />
                  </div>
                  <h4 className="mt-1 text-white">FINANÇAS</h4>
                </div>
                <div className="flex flex-col items-center">
                  <div className="w-[12vw] h-[12vw] flex items-center justify-center border-2 border-[#eaeae8] rounded-full">
                    <img
                      src="./assets/images/vagas_heineken.areas3.png"
                      alt="banner"
                      className="w-[60%]"
                    />
                  </div>
                  <h4 className="mt-1 text-white">
                    RECURSOS
                    <br />
                    HUMANOS
                  </h4>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="flex justify-center gap-8 p-12 max-[768px]:flex-col">
                <div className="flex flex-col items-center">
                  <div className="w-[12vw] h-[12vw] flex items-center justify-center border-2 border-[#eaeae8] rounded-full">
                    <img
                      src="./assets/images/vagas_heineken.areas4.png"
                      alt="banner"
                      className="w-[60%]"
                    />
                  </div>
                  <h4 className="mt-1 text-white text-center">
                    VENDAS &<br />
                    DISTRIBUIÇÃO
                  </h4>
                </div>
                <div className="flex flex-col items-center">
                  <div className="w-[12vw] h-[12vw] flex items-center justify-center border-2 border-[#eaeae8] rounded-full">
                    <img
                      src="./assets/images/vagas_heineken.areas5.png"
                      alt="banner"
                      className="w-[60%]"
                    />
                  </div>
                  <h4 className="mt-1 text-white">MARKETING</h4>
                </div>
                <div className="flex flex-col items-center">
                  <div className="w-[12vw] h-[12vw] flex items-center justify-center border-2 border-[#eaeae8] rounded-full">
                    <img
                      src="./assets/images/vagas_heineken.areas1.png"
                      alt="banner"
                      className="w-[60%]"
                    />
                  </div>
                  <h4 className="mt-1 text-white">CS&L</h4>
                </div>
              </div>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>

      <div className="flex flex-col justify-center mt-12 py-6 relative">
        <img
          src="./assets/images/vagas_heineken.cluseupfullmin.png"
          alt="banner"
          className=""
        />
        <h1
          id="gente"
          className="text-5xl absolute left-[45vw] top-[7vw] text-[#00530E] font-[HEINEKEN-ExtraBold] max-[768px]:top-[14vh] max-[768px]:left-[43vw] max-[768px]:text-3xl"
        >
          NOSSA GENTE
        </h1>
        <p
          className="absolute left-[45vw] top-[17vw] w-1/2 text-2xl text-[#00530E] max-[768px]:top-[35vh]
        max-[768px]:left-0 max-[768px]:w-full max-[768px]:text-xl max-[768px]:text-center max-[768px]:px-[7vw]"
        >
          Nós valorizamos a diversidade e sabemos que um time formado por
          pessoas com perfis diversos nos torna tão fortes e únicos quanto
          nossas marcas.
          <br />
          <br />
          Nosso valor “respeito” é o caminho para um mundo mais inclusivo,
          independente da sua deficiência, raça, gênero, orientação sexual e
          religião.
        </p>
      </div>

      <h1
        id="seletivo"
        className="text-5xl py-6 text-center text-[#00530E] font-[HEINEKEN-ExtraBold] max-[768px]:mt-[50vh] max-[768px]:text-4xl"
      >
        PROCESSO SELETIVO
      </h1>
      <div className="flex justify-center mt-12 py-6 max-[768px]:mt-0">
        <img
          src="./assets/images/vagas_heineken.Prancheta1.png"
          alt="banner"
          className="w-[15%]"
        />
        <img
          src="./assets/images/vagas_heineken.Prancheta2.png"
          alt="banner"
          className="w-[15%]"
        />
        <img
          src="./assets/images/vagas_heineken.Prancheta3.png"
          alt="banner"
          className="w-[15%]"
        />
        <img
          src="./assets/images/vagas_heineken.Prancheta4.png"
          alt="banner"
          className="w-[15%]"
        />
        <img
          src="./assets/images/vagas_heineken.Prancheta5.png"
          alt="banner"
          className="w-[15%]"
        />
        <img
          src="./assets/images/vagas_heineken.Prancheta7.png"
          alt="banner"
          className="w-[15%]"
        />
      </div>

      <div
        id="vagas"
        className="flex items-center justify-around gap-[20vw] mt-[20vh] p-[5vw] bg-wrapper-6 max-[768px]:flex-col max-[768px]:px-[7vw]"
      >
        <div className="flex flex-col">
          <h1 className="text-6xl text-[#00530E] font-[HEINEKEN-ExtraBold] max-[768px]:text-center">
            VAGAS
          </h1>
          <p className="text-[#00530E] text-xl mb-1 ml-1">Área de atuação:</p>
          <select
            onChange={onChangeFilterJobs}
            className="filter-btn w-[350px] mb-4 p-2 cursor-pointer max-[768px]:w-full"
          >
            <option value="">Todas as cidades</option>
            {jobPositionCity.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
              </option>
            ))}
          </select>
          <select
            onChange={onChangeFilterJobsTitle}
            className="filter-btn w-[350px] mb-4 p-2 cursor-pointer max-[768px]:w-full"
          >
            <option value="">Todas os cargos</option>
            {jobPositionTitle.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name}
              </option>
            ))}
          </select>
        </div>
        <div className="w-[50%] max-[768px]:w-full">
          {showLoader && (
            <div className="w-full flex flex-col items-center mt-20 max-[768px]:w-full">
              <Spinner animation="grow" variant="success" />
              <h4 className="text-white mt-4">Carregando</h4>
            </div>
          )}
          {!showLoader && currentEffectiveJobs.length ? (
            <>
              <ul className="flex flex-col gap-6 pl-0">
                {currentEffectiveJobs.map((job, i) => (
                  <li className="jobs-list" key={i}>
                    <div className="w-[50%] max-[768px]:w-full max-[768px]:p-0">
                      <p className="text-[#00530E] !m-0 max-[768px]:text-center">
                        {job.name}
                      </p>
                    </div>
                    <h5 className="w-[20%] text-[#00530E] text-center max-[768px]:w-full">
                      {job.stateName}
                    </h5>
                    <div className="w-[25%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                      <Button
                        className="py-3 px-4 cursor-pointer self-end !bg-[#00530E]"
                        variant="success"
                        href={job.shortUrl}
                        target="_blank"
                      >
                        candidatar-se
                      </Button>
                    </div>
                  </li>
                ))}
              </ul>
              <ReactPaginate
                containerClassName="pagination"
                breakLabel="..."
                nextLabel="Próximo >"
                onPageChange={handlePageClickEffectiveJobs}
                marginPagesDisplayed={2}
                pageCount={pageCountEffectiveJobs}
                forcePage={currentPage}
                previousLabel="< Anterior"
                renderOnZeroPageCount={null}
              />
            </>
          ) : null}
          {!showLoader && !currentEffectiveJobs.length ? (
            <div className="jobs-list !justify-center">
              <h2 className="text-[#00530E] text-xl">
                Não encontramos resultados para sua busca.
              </h2>
            </div>
          ) : null}
        </div>
      </div>

      <div
        className="flex flex-col justify-center items-center gap-2 py-[15vh] max-[768px]:py-[5vh]
      max-[768px]:px-[7vw] max-[768px]:text-center"
      >
        <h1 className="text-3xl text-[#00530E] font-[HEINEKEN-ExtraBold] max-[768px]:text-2xl">
          Confira outras oportunidades no Grupo HEINEKEN Brasil em nossa página
          de carreiras
        </h1>
        <Button
          className="py-3 px-5 cursor-pointer !bg-[#00530E]"
          variant="success"
          href="https://agegate.theheinekencompany.com/br/agegateway?oru=https%3a%2f%2fcareers.theheinekencompany.com%2fBrazil%2f%3flocale%3dpt_BR&opco=Brazil&returnurl=%2f?oru%3dhttps%253a%252f%252fcareers.theheinekencompany.com%252fBrazil%252f%253flocale%253dpt_BR%26opco%3dBrazil"
          target="_blank"
        >
          ACESSE
        </Button>
      </div>

      <div>
        <img
          src="./assets/images/vagas_heineken.footer.png"
          alt="banner"
          className="rounded-none"
        />
      </div>

      <footer className="bg-[#2074D9] text-white py-8">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="mb-2">
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p>
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
            <p>
              A Randstad trata dados pessoais de acordo com a LGPD (Lei
              13.709/18). Leia nosso{" "}
              <a
                href="https://www.randstad.com.br/sobre-sua-privacidade/"
                target="_blank"
                className="text-white underline hover:no-underline"
                rel="noreferrer"
              >
                Aviso de Privacidade
              </a>
              .
            </p>
          </div>

          <div className="flex space-x-4 mb-12">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
